import React, { createContext, useContext, useState, useEffect } from "react";
import { useSocket } from "./SocketContext"; // Assuming you already have a SocketContext
import { toast, ToastContainer } from "react-toastify";
import userplace from "../assets/img/orders/orderDetail/userplace.png";
import { CONSTANTS } from "./constant";
import { useNavigate } from "react-router-dom";
const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [datas, setDatas] = useState([]);
  const [notificationsCount, setNotificationsCount] = useState([]);
  const [orderStatuses, setOrderStatuses] = useState(false);
  const [opened , setOpened] = React.useState(false)

  const { socket } = useSocket(); // Using your socket from the context or props
  const navigate = useNavigate();

  useEffect(() => {
    console.log("hellloo globerly");
    if (socket) {
      socket.on("message", (data) => {
        console.log("New message:", data);

        // Add the new message to the list of messages
        setMessages((prevMessages) => [...prevMessages, data?.message]);

        // Update the last message in the conversation
        if (data?.message?.conversation_id == data?.conversation?._id) {
          console.log("heyyyyyyyy");
          toast.info(
            <div>
              <div className="font-poppins font-semibold">
                New message from {data?.message?.sender_info?.first_name}{" "}
                {data?.message?.sender_info?.last_name}
              </div>
              <p>{data?.message?.text}</p>
            </div>,
            {
              position: "bottom-right",
              autoClose: 5000, // 5 seconds
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              onClick: () => {
                navigate(
                  `/admin/customer-support/customer-tables?conversation_id=${data?.message?.conversation_id}`
                );
              },
              icon: (
                <img
                  src={
                    data?.message?.sender_info?.profile_image?.[0]?.file_url
                      ? CONSTANTS?.IMG_DIRECTORY +
                        data?.message?.sender_info?.profile_image?.[0]?.file_url
                      : userplace
                  }
                  alt="Profile"
                  style={{
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    objectFit: "cover",
                  }}
                />
              ),
            }
          );
        }
      });

      return () => {
        socket.off("message");
      };
    }
  }, [socket, navigate]);

  useEffect(() => {
    console.log("notification effecrt");
    if (socket) {
      console.log("socket notifivation", socket);
      socket.on("notification", (data) => {
        // setNotificationsCount(data?.notifications);
        setNotificationsCount((prevNotifications) => [
          ...prevNotifications,
          data?.notifications,
        ]);

        console.log("notificatoin====> data", data);

        // If the message belongs to the current conversation, update the last message in the table
      });
      return () => {
        socket.off("notification");
      };
    }
  }, [socket, navigate, orderStatuses]);

  console.log("sockkkkkk", socket);

  console.log("orderStatuses", orderStatuses);
  const handleorderStatus = () => {
    setOrderStatuses((prevStatus) => !prevStatus);
  };

  return (
    <MessageContext.Provider
      value={{
        messages,
        datas,
        notificationsCount,
        setNotificationsCount,
        handleorderStatus,
        orderStatuses,
        setOpened,
        opened
      }}
    >
      {children}
      {/* <ToastContainer /> */}
    </MessageContext.Provider>
  );
};

export const useMessages = () => useContext(MessageContext);
